import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import { ClientNotifier } from "../../scripts/ah.mb.client-notifications";
import { ModelNotifier } from "../../scripts/model-notifier";
import { modelServices } from "../../scripts/ah.mb.ui.model-services";
import { bootbox } from "../../infrastructure/bootbox-shim";

@Component
export default class ModelValidation extends Vue {

    @Prop()
    modelId: string;

    // Create user notifier
    userNotifier = new ClientNotifier();

    // Model change observer
    modelObserver = new ModelNotifier();

    // Create modelServices
    modelServices = new modelServices(this.modelObserver);

    isProcessingFix: boolean = false;
    isProblemsFound: boolean = false;

    mainTable: DataTables.Api;

    mounted() {
        this.populateTable(this.modelId);
    }

    canFixProblems() {
        return (!this.isProcessingFix) && this.isProblemsFound;
    }

    canDownloadValidations() {
        return (!this.isProcessingFix) && this.isProblemsFound;
    }

    fixProblems() {

        this.isProcessingFix = true;
        var notification = this.userNotifier.showBusyNotification("Fixing model problems...");

        this.modelServices.fixModelProblems(this.modelId)
            .then(() => {
                this.userNotifier.clear(notification);
                this.isProcessingFix = false;
            });
    }

    // Refreshes the table
    refreshTable() {
        this.mainTable.ajax.reload();
    }

    // Downloads the validations in csv
    downloadValidations() {

        this.userNotifier.showSimpleMessage("Preparing download...")

        // Todo: Fix this url
        const url = `/api/1.0/modelvalidation/download?modelId=${this.modelId}`;

        // Ajax does not allow file downloading, do it this way
        location.href = url;
    }

    // Report table drawer
    populateTable(modelId: string) {
        const url = `/ModelValidation/${modelId}/asdatatable`;
        //const url = `/api/1.0/modelvalidation/asdatatable`;
        const tableUrl = encodeURI(url);


        const columnDefs: DataTables.ColumnSettings[] =
            [
                {
                    data: "node",
                    title: "Node",
                    //                    targets: [0],
                    searchable: true,
                    width: "50%",


                    // Render link to the node
                    render: (data) => {

                        const nodeId = data;
                        if (data) {

                            return `<a class="node-link" data-nodeId="${nodeId}"><strong>${nodeId}</strong></a>`;
                        }
                        return "";
                    }


                },
                {
                    title: "Severity",
                    //                    targets: [1],
                    data: "severity",
                    searchable: true,
                    width: "10%"
                },
                {
                    title: "Message",
                    //                    targets: [1],
                    data: "failureMessage",
                    searchable: true,
                    width: "40%"
                }
            ];




        const tableSettings: DataTables.Settings =

        {
            processing: true,
            serverSide: true,
            ajax:
            //(data: object, callback: ((data: any) => void), settings: DataTables.SettingsLegacy) => {

            //    const body = JSON.stringify(data);

            //    FetchWrapper.fetch(tableUrl,
            //            {
            //                method: "post",
            //                body: body,
            //                headers: new Headers({
            //                    'Accept': "application/json",
            //                    'Content-Type': "application/json"
            //                })

            //            })
            //        .then(response => {
            //            return response.json();
            //        })
            //        .then(response => {
            //            callback(response);
            //        });

            //},
            {
                method: "post",
                url: tableUrl,
                global: false
                //contentType: "application/json",
            },
            autoWidth: false,
            paging: true,
            lengthChange: false,
            pageLength: 20,
            //"iDisplayLength": 10,
            searching: false,
            //filter: false,
            //"stateSave": true,
            //"aaSorting": [0],
            ordering: false,

            // Move search box to top left:
            //"sDom": "flrtip",

            // Done drawing callback
            drawCallback: (oSettings => {

                // Enable/disable button
                var errorCount = oSettings.fnRecordsTotal();
                if (errorCount === 0) {

                    this.isProblemsFound = false;
                    bootbox.alert("No validation failures found");
                } else {
                    this.isProblemsFound = true;
                    bootbox.alert(errorCount.toString() + " validation failures found");
                }

                $(".node-link")
                    .click(e => {
                        var nodeId = e.currentTarget.attributes["data-nodeid"];
                        this.$router.push({
                            name: "model-editor", params: {
                                modelId: this.modelId,
                                targetSector: nodeId.value
                            }
                        });

                        e.preventDefault();

                    });

            }),

            // Custom no data message
            language: {
                emptyTable: "No validation failures found",
                processing: 'Processing... <img src="dist/images/ajax-loader.gif">'
            },

            columns: columnDefs

        }


        this.mainTable = $("#mainTable").DataTable(tableSettings);
    };

}



// WEBPACK FOOTER //
// ./ClientApp/components/model-validation/model-validation.ts